<template>
	<div>
		<el-dialog title="新增规格值" :visible.sync="visible" width="60%" :before-close="handleClose">
			<div style="padding: 20px 0 0 20px">
				{{ skuItem.skuNameKv.kvName }}：
				<el-input size="small" style="width: 40%" v-model="specName" placeholder="请输入规格值"></el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="handleConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { postJson } from "@/utils/request.js";
	export default {
		props: {
			shopProduct: {
				type: Object,
				default: () => ({}),
			},
			visible: {
				type: Boolean,
				default: false,
			},
			skuItem: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				specName: "",
			};
		},
		methods: {
			async handleConfirm() {
				if (!this.specName) {
					this.$message({
						message: "请输入规格值",
						type: "warning",
					});
					return;
				}
				let params = {
					productId: this.shopProduct.id,
					skuSpecList: [{ skuId: this.skuItem.id, specName: this.specName }],
					price: 0,
					stock: 0,
					pic: "",
				};
				let res = await postJson(`/shop/product/addSkuValue`, params);
				if (res.success) {
					this.$message({
						message: "规格值新增成功！",
						type: "success",
					});
					this.$emit("close", true);
				} else {
					this.$message({
						message: res.msg,
						type: "warning",
					});
				}
			},
			handleClose() {
				this.$emit("close");
			},
		},
	};
</script>

<style scoped></style>
